import * as React from "react";
import SellerList from "../sellersList";
import {
  Box,
  Typography,
  useMediaQuery,
  // useTheme,
} from "@mui/material";
import Footer from "../footer";
import Tab from "@mui/material/Tab";
import SubSellerList from "../subSellersList";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import UserManagement from "../manageUsers";
import ResponsiveTabsTable from "../commonComponents/paymentCatalogue";

const Dashboard = ({
  val,
  type,
  flag,
  paymentRole,
  fopAddingName,
  hideSellerSubSeller,
}) => {
  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  // const parentRef = React.useRef(null)
  // const childRef = React.useRef(null)

  // const handleParentScroll = () => {
  //   const parentEle = parentRef.current
  //   const childEle = childRef.current

  //   console.log(parentEle.scrollTop, parentEle.clientHeight, parentEle.scrollHeight)

  //   if (parentEle.scrollTop + parentEle.clientHeight >= parentEle.scrollHeight) {
  //     childEle.style.overflowY = 'scroll'
  //   } else {
  //     childEle.style.overflowY = 'hidden'
  //   }
  // }

  // React.useEffect(() => {
  //   const parentEle = parentRef.current
  //   if (parentEle)
  //   parentEle.addEventListener('scroll', handleParentScroll)

  //   return () => {
  //     parentEle.removeEventListener('scroll',handleParentScroll)
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [parentRef.current])

  // const [value, setValue] = React.useState(val ? val : '1');

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 2 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  // const theme = useTheme();

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [value, setValue] = React.useState(val ? Number(val) : 0);
  const [selectedTab, setSelectedTab] = React.useState(type ? Number(type) : 0);
  const [sellerTab, setSellerTab] = React.useState(false);
  const [subSellerTab, setSubSellerTab] = React.useState(false);
  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setSellerTab(true);
      setSubSellerTab(false);
    } else if (newValue === 1) {
      setSubSellerTab(true);
      setSellerTab(false);
    }
  };

  const handleTabsChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        top: "4rem",
        position: "relative",
        // px: isMobile ? "1rem" : "3rem",
        my: 3,
      }}
    >
      <>
        {!isMobile && (
          <Box
            sx={{
              borderBottom: 2,
              borderColor: "divider",
              boxShadow: "0 4px 12px -2px #ccc",
              position: "sticky",
              top: 80,
              zIndex: 150,
              backgroundColor: "#fff",
            }}
          >
            <Tabs
              value={value}
              onChange={(handleTabsChange, handleChange)}
              bvalue={selectedTab}
            >
              {!hideSellerSubSeller ? (
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                  label="SellerList"
                  {...a11yProps(0)}
                />
              ) : null}
              {!hideSellerSubSeller ? (
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: "600",
                  }}
                  label="Sub-Seller List"
                  {...a11yProps(1)}
                />
              ) : null}
              {paymentRole ? (
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: "600",
                  }}
                  label="Payment Catalogue"
                  {...a11yProps(2)}
                />
              ) : null}
              {flag ? (
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: "600",
                  }}
                  label="Manage Users"
                  {...a11yProps(paymentRole ? 3 : 2)}
                />
              ) : null}
            </Tabs>
          </Box>
        )}

        {!hideSellerSubSeller ? (
          <CustomTabPanel value={value} index={0}>
            <SellerList sellerTab={sellerTab} />
          </CustomTabPanel>
        ) : null}
        {!hideSellerSubSeller ? (
          <CustomTabPanel value={value} index={1}>
            <SubSellerList subSellerTab={subSellerTab} />
          </CustomTabPanel>
        ) : null}
        {paymentRole ? (
          <CustomTabPanel value={value} index={!hideSellerSubSeller ? 2 : 0}>
            <ResponsiveTabsTable
              subSellerTab={subSellerTab}
              fopAddingName={fopAddingName}
            />
          </CustomTabPanel>
        ) : null}
        {flag ? (
          <CustomTabPanel value={value} index={paymentRole ? 3 : 2}>
            <UserManagement subSellerTab={subSellerTab} />
          </CustomTabPanel>
        ) : null}
      </>

      {/* {state.selectedSellerID ? <SellerProfile /> : <SellerList />} */}
      <Footer />
    </Box>
  );
};

export default Dashboard;
